import VueCropper from 'vue-cropper'
// 导入 element-ui 组件库及样式
import ElementUI, { Message } from 'element-ui'
import 'element-ui/packages/theme-chalk/src/index.scss'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import * as filters from '@/filters'

// 导入 svg 图标
import '@/icons'

// 导入全局自定义样式
import '@/assets/styles/index.scss'

// 导入指令
// import DragDialog from '@/directives/drag-dialog'
import vClickOutside from 'v-click-outside'

// 导入业务组件
import Waiting from '@/components/waiting'
import SvgIcon from '@/components/svg-icon'
import JhEchart from '@/components/jh-echart'
import JhScreenfull from '@/components/jh-screenfull'

// Openlayers 组件
import OlMap from '../components/ol-map'
import OlDraw from '../components/ol-draw'
import OlDrawPoint from '../components/ol-draw-point'
import OlGeomPolygon from '../components/ol-geom-polygon'
import OlGeomPoint from '../components/ol-geom-point'
import OlView from '../components/ol-view'
import OlLayerTile from '../components/ol-layer-tile'
import OlLayerVector from '../components/ol-layer-vector'
import OlSourceVector from '../components/ol-source-vector'
import OlSourceXyz from '../components/ol-source-xyz'
import OlSourceTilewms from '../components/ol-source-tilewms'
import OlSourceTile from '../components/ol-source-tile'
import OlOverlayer from '../components/ol-overlayer'
import OlSourceGeoTiff from '../components/ol-source-geotiff'
import OlLayerGeoTiff from '../components/ol-layer-geotile'
import datasetMap from '../components/datasetMap'
import landPopup from '../components/landPopup'







// 第三方组件
import SlideVerify from 'vue-monoplasty-slide-verify'
import Treeselect from '@riophae/vue-treeselect'

export default {
  install (Vue) {
    // 设置为 false 以阻止 vue 在启动时生成生产提示。
    // https://cn.vuejs.org/v2/api/#productionTip
    Vue.config.productionTip = false

    // 当前环境
    Vue.prototype.$env = process.env.NODE_ENV

    // 当前的 baseUrl
    Vue.prototype.$baseUrl = process.env.BASE_URL

    Vue.prototype.$waiting = Waiting
    Vue.prototype.Message = Message
    // 过滤查询参数
    Vue.prototype.filterQuery = (filter) => {
      const query = {}
      for (const pro in filter) {
        if (filter[pro]) {
          query[pro] = filter[pro]
        }
      }
      query.timestamp = new Date().getTime()
      return query
    }

    // 成功提示
    Vue.prototype.successTip = (message) => {
      if (document.getElementsByClassName('el-message').length === 0) {
        Message({ type: 'success', message })
      }
    }

    // 错误提示
    Vue.prototype.errorTip = (message) => {
      if (document.getElementsByClassName('el-message').length === 0) {
        Message({ type: 'error', message })
      }
    }

    // 引入 element-ui
    Vue.use(ElementUI)

    // 引入截图组件
    Vue.use(VueCropper)

    // 引入滑动验证组件
    Vue.use(SlideVerify)
    // vue-treeselect
    Vue.component(Treeselect.name, Treeselect)

    // 注册组件
    Vue.component(SvgIcon.name, SvgIcon)
    Vue.component(JhEchart.name, JhEchart)
    Vue.component(JhScreenfull.name, JhScreenfull)
    Vue.component(SvgIcon.name, SvgIcon)
    Vue.component(OlMap.name, OlMap)
    Vue.component(OlDraw.name, OlDraw)
    Vue.component(OlDrawPoint.name, OlDrawPoint)
    Vue.component(OlGeomPolygon.name, OlGeomPolygon)
    Vue.component(OlGeomPoint.name, OlGeomPoint)
    Vue.component(OlView.name, OlView)
    Vue.component(OlLayerTile.name, OlLayerTile)
    Vue.component(OlLayerVector.name, OlLayerVector)
    Vue.component(OlSourceVector.name, OlSourceVector)
    Vue.component(OlSourceXyz.name, OlSourceXyz)
    Vue.component(OlSourceTilewms.name, OlSourceTilewms)
    Vue.component(OlSourceTile.name, OlSourceTile)
    Vue.component(OlOverlayer.name, OlOverlayer)
    Vue.component(OlSourceGeoTiff.name, OlSourceGeoTiff)
    Vue.component(OlLayerGeoTiff.name, OlLayerGeoTiff)
    Vue.component(datasetMap.name, datasetMap)
    Vue.component(landPopup.name, landPopup)







    // 注册过滤器
    Object.keys(filters).forEach(key => {
      Vue.filter(key, filters[key])
    })

    // 注册指令
    Vue.use(vClickOutside)
    // Vue.directive(DragDialog.name, DragDialog)
  }
}
